export default __webpack_public_path__ + "static/media/reduce-cost.25a2134d.svg";